"use client";

import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { TransitionRouter, useTransitionRouter, useTransitionState } from "next-transition-router";
import ScrollFix from "./scrollFix";
import Loader from "@/app/templates/photostudio/loader";
import { usePathname } from "next/navigation";

export function PageWrapper({ children }: { children: React.ReactNode }) {
  const barsRef = useRef<HTMLDivElement | null>(null);
  const noTransitionPaths = ["/me", "/templates/e-commerces"];
  const pathname = usePathname();
  const shouldSkipTransition = noTransitionPaths.some((path) => pathname.startsWith(path));
  if (shouldSkipTransition) {
    return (
      <>
        <ScrollFix />
        {children}
      </>
    );
  }
  return (
    <TransitionRouter
      auto={true}
      leave={(next) => {
        const bars = barsRef.current?.children;
        if (!bars) {
          next();
          return;
        }

        const tl = gsap.timeline({ onComplete: next });

        // Content keluar + bars masuk
        tl.to(
          bars,
          {
            scaleY: 1,
            duration: 0.6,
            stagger: 0.05,
            ease: "power3.inOut",
            transformOrigin: "bottom"
          },
          0
        );

        return () => tl.kill();
      }}
      enter={(next) => {
        const bars = barsRef.current?.children;
        if (!bars) {
          next();
          return;
        }

        const tl = gsap.timeline({ onComplete: next });

        // Reset posisi bars sebelum animasi
        gsap.set(bars, {
          scaleY: 1,
          transformOrigin: "top"
        });

        // Bars keluar
        tl.to(bars, {
          scaleY: 0,
          duration: 0.8,
          stagger: 0.05,
          ease: "power3.inOut",
          transformOrigin: "top"
        });

        return () => tl.kill();
      }}
    >
      <ScrollFix />
      <main className=''>{children}</main>

      <div ref={barsRef} className='fixed inset-0 z-50 pointer-events-none flex'>
        {Array.from({ length: 12 }).map((_, i) => (
          <div key={i} className='flex-1 bg-[rgb(229,255,191)] scale-y-0' />
        ))}
      </div>
    </TransitionRouter>
  );
}
